import * as React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import ImportCardDataGrid from "./ImportCardDataGrid";
import MuiSelectDropdown from "./MuiSelectDropdown";
import { createCardsFromCSV } from "../../../../../sevices/apiCards";
import useToastPromise from "../../../../../hooks/useToast";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";

export default function ImportCardFromCSV({
  openImportCard,
  closeImportCard,
  data,
  closeCSV,
}) {
  const [userId, setUserId] = useState(null);
  const [isValidForSubmit, setIsValidForSubmit] = useState(true);
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const { showToastPromise } = useToastPromise();
  const handleClose = () => {
    closeImportCard(false);
  };

  const handleUserId = (Id) => {
    setUserId(Id);
  };

  const formatDescriptionAsHTML = (description) => {
    // Here you can customize the HTML formatting as needed
    return `<p>${description.replace(/\n/g, "</p><p>")}</p>`;
  };

  const { mutate: createCardsFromCSVMutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(createCardsFromCSV, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [`boards`],
      });

      queryClient.invalidateQueries({
        queryKey: [`cards`, id],
      });
      closeImportCard(false);
      closeCSV(false);
      //toast.success(res.data.message);
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
    },
  });

  const handleSubmit = () => {
    if (!userId) {
      toast.error("Please select an assignee");
      return;
    }
    
    if (isValidForSubmit) {
      createCardsFromCSVMutate({
        assigned_to_user_id: userId,
        board_id: id,
        cards_info: data.map((item) => ({
          title: item.title,
          description: formatDescriptionAsHTML(item.description),
          allocated_hours: item.allocated_hours ? parseInt(item.allocated_hours) : null,
        })),
      });
    } else {
      setIsValidForSubmit(true);
      toast.error("Please fix the errors before submitting.");
    }
  };

  const isSubmitDisabled = !isValidForSubmit || !userId;

  return (
    <React.Fragment>
      <FormDialog
        open={openImportCard}
        handleClose={handleClose}
        handleSubmit={() => handleSubmit()}
        title={"Import Tasks"}
        buttonTxt={"Submit"}
        disabled={isSubmitDisabled}
        fullWidth={true}
        width={749}>
        <div>
          <MuiSelectDropdown handleUserId={handleUserId} />
          <ImportCardDataGrid
            data={data}
            setIsValidForSubmit={setIsValidForSubmit}
          />
        </div>
      </FormDialog>
    </React.Fragment>
  );
}
